import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as FullStar} from '@fortawesome/free-solid-svg-icons';
import { faStar as Star} from '@fortawesome/free-regular-svg-icons';
import styles from '../../styles/review/ReviewScore.module.scss';

const ReviewScore = (props) => {
    const {rating} = props;
    const score = Math.round(rating);

    let stars = [];
    for (let i=1; i<=5; i++) {
        stars.push(
            <FontAwesomeIcon width="16" height="16"  icon={i<=score ? FullStar : Star} key={i}
                className={i<=score ? styles[`star${score}`]: styles.star0}/>
        )
    }


    return (
        <div>
            {stars}
        </div>
    );
}

export default ReviewScore;